t = require('views/internal/teacup-with-helpers')('org_prefs_restrict_attachments')

module.exports = t.renderable (attachmentRestrictions) ->
  t.div ->
    t.p ->
      t.format 'choose-attachment-types'
    t.ul '.pop-over-list.checkable.left-check', ->
      t.li  { class: t.classify('active': 'computer' in attachmentRestrictions.enabled ) }, ->
        t.a { href: '#', 'data-value': 'computer' }, ->
          t.icon 'check'
          t.format 'computer'
      t.li { class: t.classify('active': 'link' in attachmentRestrictions.enabled ) }, ->
        t.a { href: '#', 'data-value': 'link', }, ->
          t.icon 'check'
          t.format 'link'
      t.li { class: t.classify('active': 'google-drive' in attachmentRestrictions.enabled ) }, ->
        t.a { href: '#', 'data-value': 'google-drive' }, ->
          t.icon 'check'
          t.format 'google-drive'
      t.li { class: t.classify('active': 'dropbox' in attachmentRestrictions.enabled ) }, ->
        t.a { href: '#', 'data-value': 'dropbox' }, ->
          t.icon 'check'
          t.format 'dropbox'
      t.li { class: t.classify('active': 'box' in attachmentRestrictions.enabled ) }, ->
        t.a { href: '#', 'data-value': 'box' }, ->
          t.icon 'check'
          t.format 'box'
      t.li { class: t.classify('active': 'onedrive' in attachmentRestrictions.enabled ) }, ->
        t.a { href: '#', 'data-value': 'onedrive' }, ->
          t.icon 'check'
          t.format 'onedrive'
      t.li '.active', ->
        t.a '.disabled', { href: '#' }, ->
          t.icon 'check'
          t.format 'trello'
          t.span '.sub-name', ->
            t.format 'trello-always-allowed'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/ent_org_prefs_attachment_restrictions.coffee